"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SearchInterfaceComponentInitializer_1 = require("../../resolvers/components/SearchInterfaceComponentInitializer");
var SitecoreExperienceEditor_1 = require("./SitecoreExperienceEditor");
var coveo_search_ui_1 = require("coveo-search-ui");
var ExternalComponentInitializer = (function () {
    function ExternalComponentInitializer(experienceEditor, searchInterfaceComponentInitializer) {
        if (experienceEditor === void 0) { experienceEditor = SitecoreExperienceEditor_1.getExperienceEditorInstance(); }
        if (searchInterfaceComponentInitializer === void 0) { searchInterfaceComponentInitializer = SearchInterfaceComponentInitializer_1.getInitializerInstance(); }
        this.experienceEditor = experienceEditor;
        this.searchInterfaceComponentInitializer = searchInterfaceComponentInitializer;
    }
    ExternalComponentInitializer.prototype.initializeExternalComponentSection = function (externalComponentsSection) {
        var searchInterface = this.findSearchInterfaceForSection(externalComponentsSection);
        if (!!searchInterface) {
            this.searchInterfaceComponentInitializer.loadComponentsWithSearchInterfaceInitialization(searchInterface, externalComponentsSection);
        }
    };
    ExternalComponentInitializer.prototype.initializeExperienceEditorHooksForExternalComponentsSection = function (externalComponentsSection) {
        var _this = this;
        var searchInterface = this.findSearchInterfaceForSection(externalComponentsSection);
        if (!!searchInterface) {
            this.experienceEditor.registerOnLoadRenderingFromUrl(function (callbackData) {
                if (!callbackData.error) {
                    var component = _this.experienceEditor.getComponentFromLoadRenderingFromUrlCallbackData(callbackData);
                    if (externalComponentsSection.contains(component)) {
                        _this.searchInterfaceComponentInitializer.loadComponentsForSearchInterface(coveo_search_ui_1.get(searchInterface, coveo_search_ui_1.SearchInterface), component);
                    }
                }
            });
        }
    };
    ExternalComponentInitializer.prototype.findSearchInterfaceForSection = function (externalComponentsSection) {
        var searchInterfaceId = externalComponentsSection.dataset.searchInterfaceId;
        var searchInterfaceElement = document.getElementById(searchInterfaceId);
        if (!!searchInterfaceElement) {
            return searchInterfaceElement;
        }
        else {
            console.warn("Could not find the search interface element with the following ID: " + searchInterfaceId + ". Validate \"data-search-interface-id\" on the external components section element.", externalComponentsSection);
        }
    };
    return ExternalComponentInitializer;
}());
exports.ExternalComponentInitializer = ExternalComponentInitializer;



//////////////////
// WEBPACK FOOTER
// ./src/base/initialization/ExternalComponentInitializer.ts
// module id = 30
// module chunks = 13 14